import { fetchModelJsonApi } from './constants';
import { addSubDirectoryPrefix } from './helper';

export function getValueFromHref<T extends { modelKey: string; activeKey: string }>(
  href: string,
  map: Record<string, T>
): T | null {
  // Remove query parameters
  const cleanHref: string = href.split('?')[0];

  // Remove .mi or .html or other suffixes
  const basePath = cleanHref.replace(/(\.mi|\.html)$/i, '');

  // Try direct match
  if (map[basePath]) return map[basePath];

  // Try match without trailing slash
  const noSlash = basePath.replace(/\/$/, '');
  if (map[noSlash]) return map[noSlash];

  // Try match with only the last segment
  const lastSegment = '/' + basePath.split('/').pop();
  if (map[lastSegment]) return map[lastSegment];

  // Try includes match for keys containing basePath
  const includesKey = Object.keys(map).find(k => k.includes(basePath));
  if (includesKey) return map[includesKey];

  return null;
}

/**
 * Fetches model JSON data for a given link using the model API endpoint.
 * Returns the parsed JSON response or null on error.
 */
export async function fetchLinkJson(link: string, additionalHeaders?: { [key: string]: string }) {
  try {
    const apiUrl = addSubDirectoryPrefix(`${fetchModelJsonApi}?model=${link}`);
    const response = await fetch(apiUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...additionalHeaders,
      },
    });
    return await response.json();
  } catch (err) {
    console.error('Error in fetching model-json:', err);
    return null;
  }
}
